import React,{useEffect} from 'react'
import Contacts from "./../Component/Contact/Contact1"
import Banner from "./../Component/Contact/Banner"

const Contact = () => {
useEffect(() => {
  window.scrollTo(0, 0);

  // Contact Page Meta Tags
  document.title = 'Rushikesh Career Guidance: Contact Us | Get In Touch With Our Expert Counsellors';

  // Set meta description dynamically
  const contactMetaDescription = document.createElement('meta');
  contactMetaDescription.name = 'description';
  contactMetaDescription.content = 'Expert guidance for medical and engineering aspirants with personalised counselling, smart college selection, and complete admission support.';
  document.head.appendChild(contactMetaDescription);

  // Set meta keywords dynamically
  const contactMetaKeywords = document.createElement('meta');
  contactMetaKeywords.name = 'keywords';
  contactMetaKeywords.content = 'NEET counselling near me, NEET admission counselling near me, NEET counsellor near me ,Medical admission guidance near me, NEET guidance center near me, Best NEET counsellor near me, NEET career guidance near me, MBBS admission counsellor near me, Medical college admission help near me, Maharashtra NEET counselling, Maharashtra MBBS admission guidance, State quota NEET counselling Maharashtra, NEET Maharashtra counselling expert, Maharashtra medical admission consultant,Private medical college admission Maharashtra, Government medical college admission guidance, RCG, RCG Counseling, Rushikesh Career Guidance';
  document.head.appendChild(contactMetaKeywords);

  // Set canonical link dynamically
  const contactCanonicalLink = document.createElement('link');
  contactCanonicalLink.rel = 'canonical';
  contactCanonicalLink.href = 'https://rcgcounselling.com/contact';
  document.head.appendChild(contactCanonicalLink);

  // Set Open Graph title dynamically
  const contactOgTitle = document.createElement('meta');
  contactOgTitle.property = 'og:title';
  contactOgTitle.content = 'Rushikesh Career Guidance: Contact Us | Get In Touch With Our Expert Counsellors';
  document.head.appendChild(contactOgTitle);

  // Set Open Graph description dynamically
  const contactOgDescription = document.createElement('meta');
  contactOgDescription.property = 'og:description';
  contactOgDescription.content = 'Expert guidance for medical and engineering aspirants with personalised counselling, smart college selection, and complete admission support.';
  document.head.appendChild(contactOgDescription);

  // Set Open Graph URL dynamically
  const contactOgUrl = document.createElement('meta');
  contactOgUrl.property = 'og:url';
  contactOgUrl.content = 'https://rcgcounselling.com/contact';
  document.head.appendChild(contactOgUrl);

  // Set Open Graph site name dynamically
  const contactOgSiteName = document.createElement('meta');
  contactOgSiteName.property = 'og:site_name';
  contactOgSiteName.content = 'Rushikesh Career Guidance';
  document.head.appendChild(contactOgSiteName);

  // Set Open Graph image dynamically
  const contactOgImage = document.createElement('meta');
  contactOgImage.property = 'og:image';
  contactOgImage.content = 'https://rcgcounselling.com/g1.jpg';
  document.head.appendChild(contactOgImage);

  // Set Open Graph secure image URL dynamically
  const contactOgImageSecure = document.createElement('meta');
  contactOgImageSecure.property = 'og:image:secure_url';
  contactOgImageSecure.content = 'https://rcgcounselling.com/g1.jpg';
  document.head.appendChild(contactOgImageSecure);

  // Set Open Graph image width dynamically
  const contactOgImageWidth = document.createElement('meta');
  contactOgImageWidth.property = 'og:image:width';
  contactOgImageWidth.content = '300';
  document.head.appendChild(contactOgImageWidth);

  // Set Open Graph image height dynamically
  const contactOgImageHeight = document.createElement('meta');
  contactOgImageHeight.property = 'og:image:height';
  contactOgImageHeight.content = '200';
  document.head.appendChild(contactOgImageHeight);

  // Cleanup on component unmount

    const contactStructuredData = document.createElement('script');
    contactStructuredData.type = 'application/ld+json';
    contactStructuredData.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "contactPoint": {
        "@type": "ContactPoint",
       
        "contactType": "Customer Service",
        "email": "help.rcginfo@gmail.com",
         "name": "Rushikesh Career Guidance",
  "telephone": "+917620582520",
              "contactType": "customer service",
               "areaServed": "IN",
                "availableLanguage": ["English", "Marathi", "Hindi"],
  "url": "https://rcgcounselling.com/",
        "description": "Expert guidance for medical and engineering aspirants with personalised counselling, smart college selection, and complete admission support.",
  "inLanguage": "en",
    "sitelinks": [
    {
      "@type": "WebPage",
      "name": "Home",
      "url": "https://rcgcounselling.com"
    },
    {
      "@type": "WebPage",
      "name": "Services",
      "url": "https://rcgcounselling.com/service"
    },
            {
      "@type": "WebPage",
      "name": "Portfolio",
      "url": "https://rcgcounselling.com/portfolio"
    },
    {
      "@type": "WebPage",
      "name": "About Us",
      "url": "https://rcgcounselling.com/about"
    },
    {
      "@type": "WebPage",
      "name": "Contact",
      "url": "https://rcgcounselling.com/Contact"
    }
  ]
      }
    });
  document.head.appendChild(contactStructuredData);

  return () => {
    document.title = 'Rushikesh Career Guidance: Contact Us | Get In Touch With Our Expert Counsellors';
    document.head.removeChild(contactMetaDescription);
    document.head.removeChild(contactMetaKeywords);
    document.head.removeChild(contactCanonicalLink);
    document.head.removeChild(contactOgTitle);
    document.head.removeChild(contactOgDescription);
    document.head.removeChild(contactOgUrl);
    document.head.removeChild(contactOgSiteName);
    document.head.removeChild(contactOgImage);
    document.head.removeChild(contactOgImageSecure);
    document.head.removeChild(contactOgImageWidth);
    document.head.removeChild(contactOgImageHeight);
      document.head.removeChild(contactStructuredData);

  };

}, []);

  return (
    <div>
      <Banner/>
<Contacts/>
    </div>
  )
}

export default Contact